import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import {
  Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import { Tooltip } from '@mui/material';

import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchDataActive, fetchData, postData, updateData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Button from '@mui/material/Button';
import {
  Search as SearchIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';

//import '../../styles.css';
function NatureIndex() {
  const inputRef = useRef(null);
  const [data, setData] = useState([]);
  const [deleteManufacture, setDeleteManufacture] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  //const [filteredData, setFilteredData] = useState([]);
  const history = useHistory(); // Access the navigation history
  const [errorMessage, setErrorMessage] = useState("");
  const { isAuthenticated, clubId, userId, branchId, permissions, logout, token } = useAuth();
  const [successMessage, setSuccessMessage] = useState("");
  //Create Constants---------------------
  const [isSubmit, setIsSubmit] = useState(false);
  const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);
  const [nature, setNature] = useState("");


  const [selectedValue, setSelectedValue] = useState(1);
  //-------------------------------------------for edit-------------------
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false); // For editing
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState(null); // Holds the person data when editing
  const [parentGroupOptions, setParentGroupOptions] = useState([]);
  const [selectedgroup, setselectedgroup] = useState("");
  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
      return;
    }

    // Token is not expired, fetch data
    fetchtableData();
    fetchParentData();
    //  inputRef.current.focus();
  }, [isAuthenticated, clubId, branchId, token, logout]);

  const fetchParentData = async () => {
    fetchData('ParentGroupApi', `/${clubId}/${branchId}`, token)
      .then((response) => {

        if (response.responseCode === '1111') {

          const options = response.response_data.map(group => ({
            value: group.Id,
            label: group.Head
          }));
          setParentGroupOptions(options);
        }
      })
      .catch((error) => {
        console.error('Error fetching Parent Group Details:', error);
      });
  };

  const fetchtableData = async () => {
    fetchData('NatureApi', `/${clubId}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching Nature Details:', error);
      });
  };


  //handle search [ITEM SEARCH]
  const [isFocused, setIsFocused] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchInput, setShowSearchInput] = useState(false);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const toggleSearchInput = () => {
    setShowSearchInput(!showSearchInput);
  };

  //search
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );


  const handleDelete = async () => {
    deleteData('AssetRegistration', `${deleteManufacture}`, token)
      .then((response) => {
        fetchtableData();
        setDeleteManufacture(null);
        setConfirmDialogOpen(false);
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
      });
  };

  const handleActivate = (manuId) => {
    activateData('AssetRegistration', `${manuId}`)
      .then(() => {
        fetchtableData();
      })
      .catch((error) => {
        console.error('Error activating record:', error);
      });
  };

  const openConfirmDialog = (manuId) => {
    setDeleteManufacture(manuId);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setDeleteManufacture(null);
    setConfirmDialogOpen(false);
  };


  //Create Section----------------------
  const handleFormSubmit = (e) => {
    e.preventDefault();
    setIsSubmit(true);
    submitData(e);

  }


  const submitData = async (e) => {
    e.preventDefault();


    // Validation
    if (!nature || !selectedgroup) {
      setErrorMessage("All fields are required!");
      setIsSubmit(false);
      return;
    }

    const naturedata = {
      Name: nature,
      CreatedBy: userId || "",
      CreatedDate: new Date(),
      ClubId: clubId || "",
      BranchId: branchId || "",
      ParentGroupId: selectedgroup.value || "",
    };


    try {
      const response = await postData('NatureApi', naturedata, token);
      console.log('Assets Created successfully:', response);
      setSuccessMessage("Assets Created successfully!");
      setErrorMessage("");

      resetForm(); // Ensure this function resets all relevant state variables
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
      window.location.reload();
    } catch (error) {
      console.error('Assets Create error:', error);
      setErrorMessage("Error creating Assets. Please try again.");
    }
    setIsModalOpenCreate(false);
  };



  const toggleModalCreate = () => {
    setIsModalOpenCreate(prev => !prev);

  };
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };


  //Edit-------------------------

  const toggleModalEdit = () => {
    setIsModalOpenEdit(prev => !prev);
    if (isModalOpenEdit) {
      resetForm(); // Only reset when modal is closing, not opening
      setEditData(null);
      setIsEditing(false);
    }
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
  };
  // Reset form fields
  const resetForm = () => {
    setNature('');

  };


  const handleEdit = (id) => {
    // Reset the fields to avoid stale data
    setNature('');


    fetchData('NatureApi', `/NatureApi/${id}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          const data = response.response_data;
          setEditData(data); // Optional, if you need to keep the full data
          setNature(data.Name);
          //setselectedgroup(data.ParentGroup);
          setIsEditing(true); // Set editing mode
          toggleModalEdit(); // Open the modal
        } else {
          console.error('Error fetching Asset details');
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  };

  const handleFormSubmitEdit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    if (isEditing && editData) {
      const updatedUsertypedata = {
        Id: editData.Id,
        Name: nature,
        ParentGroupId: selectedgroup?.value ?? editData.ParentGroupId,
        UpdatedBy: userId || "",
        UpdatedDate: new Date(),
        ClubId: clubId || "",
        BranchId: branchId || "",
        

      };

      try {
        const response = await updateData('NatureApi', editData.Id, updatedUsertypedata, token);
        console.log('Record updated successfully:', response);
        setSuccessMessage("Record updated successfully!");
        toggleModalEdit(); // Close the modal
        setTimeout(() => {
          setSuccessMessage(""); // Clear success message after a delay
        }, 3000);
        fetchtableData(); // Refresh the table data
      } catch (error) {
        console.error('Error updating record:', error);
      }
    }
  };

  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('PurchaseOrderDate');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleParentGroupChange = (selectedOption) => {
    //setselectedgroup(selectedOption); // Store the whole object

    setselectedgroup(selectedOption); // Store the whole object
    setEditData({ ...editData, ParentGroupId: selectedOption ? selectedOption.value : null }); // Update editData

  };


  const sortedData = stableSort(filteredData, getComparator(order, orderBy));
  const commonButtonStyles = {
    height: '36px',
    marginLeft: '10px',
    marginTop: '1.00%',
    marginRight: '8px',
  };

  return (
    <div className="w-full max-w-sm container mt-2 mx-auto">
      <div className='w-full mb-2 flex'>

        <h6 className='productHead flex-grow linkcolor' style={{ color: '#0e728c', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#0e728c' }}> NATURE</h6>

        <input
          className="shadow text-gray-700 leading-tight"
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearch}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          style={{
            width: isFocused ? '250px' : '140px',
            height: '30px',
            border: '1px solid #ccc',
            borderRadius: '15px',
            padding: '0 20px',
            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
            outline: 'none',
            borderColor: isFocused ? 'darkcyan' : '#ccc',
            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
            marginLeft: '10px'
          }}
        />

        <div className="button-container-1" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Tooltip
            title="Create Nature"
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: '#0e728c',
                  color: 'white',
                  border: '1px solid white',
                  fontWeight: 'bold',
                  boxShadow: 2,
                },
              },
            }}
          >
            <Button
              component={Link}
              onClick={toggleModalCreate}
              className="linkcolor"
              style={{ color: 'whitesmoke', fontsize: '11px', backgroundColor: '#27391C', height: '25px', marginLeft: '5px' }}
            >
              CREATE
            </Button>
          </Tooltip>
        </div>


      </div>


      <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#15abd2', fontFamily: 'sans-serif' }}>

              <TableRow>
                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Sl No</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Nature</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Parent Group</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Type</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontWeight: 'bold', textAlign: 'right', textTransform: 'uppercase' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ backgroundColor: '#F5F7F8' }}>
              {filteredData.map((asset, index) => (
                <TableRow
                  key={asset.Id}
                  className={asset.IsActive ? '' : 'inactiveRow'}
                  sx={{
                    backgroundColor: index % 2 === 0 ? 'white' : '#ebf9fd', // Alternate row background colors
                  }}
                >

                  <TableCell sx={{ fontSize: '14px', padding: '2px' }}>{index + 1}</TableCell>
                  <TableCell sx={{ padding: '2px' }}>{asset.Name}</TableCell>
                  <TableCell sx={{ padding: '2px' }}>{asset.ParentGroup}</TableCell>
                  <TableCell sx={{ padding: '2px' }}>{asset.ParentGroupType}</TableCell>

                  <TableCell sx={{ padding: '2px', textAlign: 'right' }}>

                    <Link to="#" onClick={() => handleEdit(asset.Id)}>
                      <Tooltip title="Edit Asset">
                        <IconButton>
                          <EditIcon style={{ fontsize: '10px', color: 'blue' }} />
                        </IconButton>
                      </Tooltip>
                    </Link>

                    <Tooltip title="Delete Asset">
                      <IconButton onClick={() => (asset.IsActive ? openConfirmDialog(asset.Id) : handleActivate(asset.Id))}>
                        {asset.IsActive ? <DeleteIcon style={{ fontsize: '10px', color: 'brown' }} /> : <ActivateIcon style={{ fontsize: '20px' }} />}
                      </IconButton>
                    </Tooltip>


                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <Dialog
              open={confirmDialogOpen}
              onClose={closeConfirmDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to delete this record?
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                <button
                  onClick={closeConfirmDialog}
                  style={{
                    backgroundColor: '#dc3545',
                    color: '#ffffff',
                    border: '1px solid #dc3545',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    marginRight: '8px',
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleDelete}
                  style={{
                    backgroundColor: '#28a745',
                    color: '#ffffff',
                    border: '1px solid #28a745',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                  }}
                >
                  Confirm
                </button>
              </DialogActions>

            </Dialog>
          </Table>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              '& .MuiTablePagination-toolbar': {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'nowrap', // Ensures everything stays in one line
                minHeight: '40px', // Keeps a proper height
              },
              '& .MuiTablePagination-selectLabel': {
                marginBottom: 0, // Fixes label misalignment
              },
              '& .MuiTablePagination-displayedRows': {
                marginBottom: 0, // Fixes row count misalignment
              },
            }}
          />

        </TableContainer>
      </div>


      {isModalOpenCreate && (
        <div className="fixed inset-0 flex items-center justify-center z-10">
          <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '40%' }}>
            <h6 style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', textAlign: 'center' }}>CREATE NATURE </h6>

            {/* Fees Description and Amount */}


            <div className="w-full mb-4 flex">
              <div className="w-1/2 mr-2">
                <label htmlFor="nature">Nature</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  value={nature}
                  onChange={(e) => setNature(e.target.value)}
                  type="text"
                  placeholder="Enter Nature"
                />
              </div>
              <div className="w-1/2 mr-2">
                <label htmlFor="parentgroup">Parent Group</label>
                <Select
                  value={selectedgroup}
                  onChange={handleParentGroupChange}
                  options={parentGroupOptions}
                  placeholder="Parent Grp"
                  isSearchable
                />
              </div>

            </div>


            {/* Action Buttons */}
            <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
              {/* <Button onClick={handleFormSubmit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c' }}>
                                Save
                            </Button>
                            <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c' }} onClick={toggleModalCreate}>
                                Cancel
                            </button> */}
              <Button onClick={handleFormSubmit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#5DB996' }}>
                Save
              </Button>
              <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#FF748B', marginLeft: '5px' }} onClick={toggleModalCreate}>
                Cancel
              </Button>
            </div>
          </div>
        </div>
      )}


      {isModalOpenEdit && (
        <div className="fixed inset-0 flex items-center justify-center z-10">
          <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '40%' }}>
            <h6 style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>EDIT NATURE</h6>
            {/* Radio Buttons for selecting One Time or Monthly */}


            {/* Fees Description and Amount */}


            <div className="w-full mb-4 flex">

              <div className="w-1/2 mr-2">
                <label htmlFor="nature">Nature</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  value={nature}
                  onChange={(e) => setNature(e.target.value)}
                  type="text"
                  placeholder="Enter Nature"
                />
              </div>
              <div className="w-1/2 mr-2">
                <label htmlFor="parentgroup">Parent Group</label>

                {/* <Select
                                    value={selectedgroup}
                                    onChange={handleParentGroupChange}
                                    options={parentGroupOptions}
                                    placeholder="Parent Grp"
                                    isSearchable
                                /> */}
                <Select
                  value={selectedgroup || (editData.ParentGroup ? { value: editData.ParentGroupId, label: editData.ParentGroup } : '')}
                  onChange={handleParentGroupChange}
                  options={parentGroupOptions}
                  placeholder="Parent Grp"
                  isSearchable
                />
              </div>
            </div>



            {/* Action Buttons */}
            <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
              {/* <Button onClick={handleFormSubmitEdit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c' }}>
                                Update
                            </Button>
                            <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c' }} onClick={toggleModalEdit}>
                                Cancel
                            </button> */}
              <Button onClick={handleFormSubmitEdit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#5DB996' }}>
                Update
              </Button>
              <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#FF748B', marginLeft: '5px' }} onClick={toggleModalEdit}>
                Cancel
              </Button>
            </div>
          </div>
        </div>
      )}


    </div>
  );
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export default NatureIndex;




